/**
 * Backend mounts all JSON routes under /api.
 * REACT_APP_API_URL may be set as https://api.example.com or https://api.example.com/api.
 */
const FALLBACK = "http://localhost:5000/api";

function normalizeApiBaseUrl(raw: string | undefined): string {
  const trimmed = (raw || FALLBACK).trim().replace(/\/+$/, "");
  if (!trimmed) return FALLBACK;
  return trimmed.endsWith("/api") ? trimmed : `${trimmed}/api`;
}

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

/** Host origin without /api (uploads, static paths). */
export const API_ORIGIN_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, "");
